"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRefsResource = handleRefsResource;
const path = __importStar(require("path"));
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
/**
 * loom://refs — list the reference docs under loom/refs/ as { id, title, file }.
 * Backs the extension's "add to requires_load" picker so it no longer reads the
 * filesystem directly (keeping vscode → mcp → app intact).
 */
async function handleRefsResource(root) {
    const loomRoot = (0, dist_1.getActiveLoomRoot)(root);
    const refsDir = path.join(loomRoot, 'loom', 'refs');
    let files = [];
    try {
        files = (await fs.readdir(refsDir)).filter(f => f.endsWith('.md'));
    }
    catch {
        files = [];
    }
    const refs = [];
    for (const file of files) {
        try {
            const doc = await (0, dist_1.loadDoc)(path.join(refsDir, file));
            refs.push({
                id: doc.id ?? file.replace(/\.md$/, ''),
                title: doc.title ?? file.replace(/-reference\.md$/, ''),
                file,
            });
        }
        catch {
            // skip unreadable / malformed reference docs
        }
    }
    return {
        contents: [{
                uri: 'loom://refs',
                mimeType: 'application/json',
                text: JSON.stringify({ refs }, null, 2),
            }],
    };
}
